import { Typography, getTheme, styled } from '~/modules';

const textMain = getTheme('text.main');

export const Wrapper = styled(Typography).attrs({
  variant: 'lg',
})`
  font-weight: 700;
  color: ${textMain};
`;
